<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Usage</h1>
            <p class="lead">View overall usage for your pupils.</p>
        </div>
    </div>
    <ReportingUsageComp
        roleView="teacher"
        :pupils="pupils"
        :classes="classes"
        :groups="groups"
        :isLoading="!(isLoaded.pupils || isLoaded.classes || isLoaded.groups)"
    />
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'reporting' } });

const store = useTeacherStore();
store.fetchPupils();
store.fetchClasses();
store.fetchGroups();
const { pupils, classes, groups, isLoaded } = storeToRefs(store);
</script>
